module.exports = __webpack_public_path__ + "static/media/m-watch-maker.c4c1eb8b.png";